<template>
  <div class="row">
    <!-- Received (this establishment is the destination) then sent (it is the
         source). Only ACCEPTED internal invoices feed these tables, so they
         always tie out with the report aggregates. -->
    <div class="col-12 mb-4" v-for="block in blocks" :key="block.key">
      <template v-if="block.key === 'received' || block.payload.lines.length">
        <h5 class="mb-2">{{ block.title }}</h5>
        <p class="text-muted small mb-2" v-if="block.key === 'received'">
          {{ $t("WEEKLY_REPORTS.INTERNAL_INVOICE_PRODUCTS_HELP") }}
        </p>

        <el-table
          :data="block.payload.lines"
          header-row-class-name="thead-light"
          class="table-responsive align-items-center table-flush"
          v-loading="loading"
        >
          <div slot="empty" class="text-center text-muted py-4">
            {{ $t("WEEKLY_REPORTS.NO_INTERNAL_INVOICES") }}
          </div>

          <el-table-column :label="$t('COMMON.PRODUCT')" min-width="240">
            <template v-slot="{ row }">
              {{ row.name }}
              <div class="text-muted small">
                {{ row.code }}<span v-if="row.sku"> · {{ row.sku }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('COMMON.CATEGORY')" min-width="150">
            <template v-slot="{ row }">
              {{ row.reporting_name || "-" }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('COMMON.QUANTITY')" min-width="110" align="right">
            <template v-slot="{ row }">{{ row.quantity }}</template>
          </el-table-column>

          <el-table-column
            :label="$t('COMMON.UNIT_PRICE')"
            min-width="130"
            align="right"
          >
            <template v-slot="{ row }">
              {{ $formatCurrency(row.average_unit_price, 4) }}
            </template>
          </el-table-column>

          <el-table-column :label="$t('COMMON.TOTAL')" min-width="130" align="right">
            <template v-slot="{ row }">
              {{ $formatCurrency(row.amount) }}
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('WEEKLY_REPORTS.INVOICES_COUNT')"
            min-width="110"
            align="right"
          >
            <template v-slot="{ row }">{{ row.invoices_count }}</template>
          </el-table-column>
        </el-table>

        <div class="text-right mt-2" v-if="block.payload.lines.length">
          <strong>
            {{ $t("COMMON.TOTAL") }} :
            {{ $formatCurrency(block.payload.total_amount) }}
          </strong>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Table, TableColumn } from "element-ui";

const EMPTY_BLOCK = { lines: [], total_quantity: 0, total_amount: 0 };

export default {
  name: "weekly-report-internal-invoice-products",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  props: {
    weeklyReport: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      payload: {
        received: { ...EMPTY_BLOCK },
        sent: { ...EMPTY_BLOCK },
      },
    };
  },
  computed: {
    blocks() {
      return [
        {
          key: "received",
          title: this.$t("WEEKLY_REPORTS.INTERNAL_INVOICE_PRODUCTS_RECEIVED"),
          payload: this.payload.received || { ...EMPTY_BLOCK },
        },
        {
          key: "sent",
          title: this.$t("WEEKLY_REPORTS.INTERNAL_INVOICE_PRODUCTS_SENT"),
          payload: this.payload.sent || { ...EMPTY_BLOCK },
        },
      ];
    },
  },
  created() {
    this.getProducts();
  },
  watch: {
    "weeklyReport.id": {
      handler() {
        this.getProducts();
      },
    },
  },
  methods: {
    async getProducts() {
      if (!this.weeklyReport.id) return;
      this.loading = true;
      try {
        this.payload = await this.$store.dispatch(
          "weeklyReports/internalInvoiceProducts",
          this.weeklyReport.id
        );
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
